import React, { Component } from 'react'
import { observer } from 'mobx-react'
import style from './style.module.less'
import Img from '@UI/Img'
import { Flex } from 'hljd'
import { ctrlTextLen } from '@hlj/hlj-utils'
import { CASE_HOT_TAG } from '@constant'

@observer
export default class extends Component {
  render() {
    const {
      cover_path,
      mode,
      title,
      shoot_place,
      wedding_day,
      hot_tag
    } = this.props

    const imgStyle = {
      width: 160,
      height: 90,
      backgroundColor: '#eee',
      borderRadius: 12
    }

    const isFake = mode === 'fake'

    return (
      <div className={style.item}>
        {isFake ? (
          <div style={imgStyle} />
        ) : (
          <div style={{ position: 'relative' }}>
            <Img
              src={cover_path}
              style={{
                ...imgStyle,
                verticalAlign: 'middle'
              }}
            />

            <div className={style.planEmpty}>{CASE_HOT_TAG[hot_tag + '']}</div>

            <div>
              <p>{ctrlTextLen(title, '10', '...')}</p>
              <Flex sp className={style.plantext}>
                <span>{wedding_day}</span>
                <span>{ctrlTextLen(shoot_place, '5', '...')}</span>
              </Flex>
            </div>
          </div>
        )}
      </div>
    )
  }
}
